export default "__VITE_ASSET__kx7HV_LI__"